<script setup>
import { swalError, swalSuccess } from '@/helper';
import { create_user } from '@/services/user';
import { get_roles } from '@/services/roles';
import { ref, onMounted } from 'vue';


const user = ref({
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  role_id: null
})
const roles = ref([])

onMounted(async () => {
  const response = await get_roles()
  if (!response.error) {
    roles.value = response.data.data.map(role => ({
      id: role.id,
      name: role.attributes.name
    }))
  }
})
const isUpdating = ref(false)
async function addUser(){
  isUpdating.value = true
  let response = await create_user(user.value)
  isUpdating.value = false
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('User has been created')
  location.reload()
}
</script>

<template>
  <Breadcrumbs main="New User"/>
  <div class="container-fluid text-start">
    <form class="card" @submit.prevent="addUser()">
      <div class="card-header ">
        <h4 class="card-title mb-0">User Profile</h4>
        <div class="card-options"><a class="card-options-collapse" href="javascript:void(0)"
          data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove"
          href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">First Name</label>
              <input class="form-control" type="text" 
                placeholder="First name" v-model="user.first_name"
              >
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Last Name</label>
              <input class="form-control" type="text" 
                placeholder="Last Name" v-model="user.last_name"
              >
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Email
              </label>
              <input class="form-control" type="email" 
                placeholder="Email" v-model="user.email" 
              >
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Password
              </label>
              <input class="form-control" type="password" 
                placeholder="Password" v-model="user.password" 
              >
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Role</label>
              <multiselect 
                v-model="user.role_id" 
                placeholder="Select role"
                :options="roles"
                valueProp="id"
                label="name"
                track-by="name"
              ></multiselect>
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div>
              <label class="form-label">About Me</label>
              <textarea class="form-control" rows="5" 
                placeholder="Enter About your description"
              ></textarea>
            </div>
          </div> -->
        </div>
      </div>
      <div class="card-footer text-end">
        <button class="btn btn-primary" type="submit">
          <span v-if="isUpdating">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Updating...</span>
            </div>
          </span>
          <span v-else>
            Create User
          </span>
        </button>
      </div>
    </form>
  </div>
</template>